import { render, staticRenderFns } from "./ApplicationStatus.vue?vue&type=template&id=bd43fda6&scoped=true"
import script from "./ApplicationStatus.vue?vue&type=script&lang=ts"
export * from "./ApplicationStatus.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationStatus.vue?vue&type=style&index=0&id=bd43fda6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43fda6",
  null
  
)

export default component.exports